import serviceList from "common/const";
import { response } from "network/response";
// 截取 url参数
export function getUrlParam (paraName) {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}
// 下载文件
export const downloadFile = (url, name) => {
  window
    .fetch(url)
    .then(
      (res) => {
        if (res.status === 200) {
          return res.blob();
        }
        return false;
      },
      (error) => {
        console.log(error);
      }
    )
    .then((blob) => {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      // 使用获取到的blob对象创建的url
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      // 指定下载的文件名
      a.download = `${name}`;
      a.click();
      document.body.removeChild(a);
      // 移除blob对象的url
      window.URL.revokeObjectURL(url);
    });
};
//url获取参数
export function getUrl (paraName) {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[0].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[1] == paraName) {
        return arr[0];
      }
    }
    return "";
  } else {
    return "";
  }
}
//时间对比 yyyy-mm-dd hh-mm
export const compareTime = (gettime) => {
  var today = new Date()  //获取当前时间
  gettime = gettime.replace(/-/g, '-');
  //转化成时间戳作比较
  var endTime = new Date(gettime) //自己的时间
  if (today.getTime() > endTime.getTime()) {
    //当前时间大于我的时间
    return false
  } else {
    //当前时间小于我的时间
    return true
  }
}
//结束时间减去开始时间
export function getTimeDiff (startTimestamp, endTimestamp) {
  console.log(startTimestamp, endTimestamp);
  const stateTime = parseInt(new Date(startTimestamp).getTime());
  const endTime = parseInt(new Date(endTimestamp).getTime());
  const diff = endTime - stateTime; //传进来两个时间戳（单位为毫秒），结束时间减去开始时间得到一个时间戳的差值
  console.log(diff, 'diffdiff');
  const date = new Date(diff)
  const day = date.getDate() // 日
  return day
}
// 获取当前时间
export function getCurrentDateTime () {
  const now = new Date();
  const year = now.getFullYear();
  const month = padNumber(now.getMonth() + 1); // 月份是从0开始的
  const day = padNumber(now.getDate());
  const hours = padNumber(now.getHours());
  const minutes = padNumber(now.getMinutes());
  return `${year}-${month}-${day} ${hours}:${minutes}:00`;
}
function padNumber (num) {
  return num < 10 ? '0' + num : num;
}

export async function copyText (that, copytext) {
  /**
    * element 表格复制内容 
    * @copytext :String
    * @return 返回值的描述
   */
  if (copytext) {
    const data = await that.$copyText(copytext)
    if (data.action == 'copy') {
      return that.$message.success('复制内容成功')
    }
  } else {
    return that.$message.error('复制内容为空')
  }
}
export function getDayAll (starDay, endDay) {
  var arr = [];
  var dates = [];
  // 设置两个日期UTC时间
  var db = new Date(starDay);
  var de = new Date(endDay);
  // 获取两个日期GTM时间
  var s = db.getTime() - 24 * 60 * 60 * 1000;
  var d = de.getTime() - 24 * 60 * 60 * 1000;
  // 获取到两个日期之间的每一天的毫秒数
  for (var i = s; i <= d;) {
    i = i + 24 * 60 * 60 * 1000;
    arr.push(parseInt(i));
  }
  // 获取每一天的时间  YY-MM-DD
  for (var j in arr) {
    var time = new Date(arr[j]);
    var year = time.getFullYear(time);
    var mouth =
      time.getMonth() + 1 >= 10
        ? time.getMonth() + 1
        : "0" + (time.getMonth() + 1);
    var day = time.getDate() >= 10 ? time.getDate() : "0" + time.getDate();
    var YYMMDD = year + "-" + mouth + "-" + day;
    dates.push(YYMMDD);
  }
  return dates;
}
//时间戳转日期
export function setTime (fmt) {
  const time = new Date(Number(fmt));
  const Y = time.getFullYear();
  const M = (time.getMonth() + 1).toString().padStart(2, "0");
  const D = time.getDate().toString().padStart(2, "0");
  const h = time.getHours().toString().padStart(2, "0");
  const m = time.getMinutes().toString().padStart(2, "0");
  const s = time.getSeconds().toString().padStart(2, "0");
  return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}
// 日期转时间戳
export function setTimeDay (hdrq) {
  var timestr = hdrq.replace(/-/g, '/')
  return new Date(timestr).getTime();
}
//获取当前日期
export function getDate () {
  //获取当前日期函数
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate(); // 获取当前日(1-31)
  if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
  if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
  return `${year}-${month}-${strDate}`;
}
//获取当前年月
export function getMonth () {
  let date = new Date()
  let year = date.getFullYear() //获取完整的年份(4位)
  let month = date.getMonth() + 1
  if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
  return `${year}-${month}`
}
//上个月
export function getLastMonth (date) {
  const now = new Date(date)
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const nowMonthDay = new Date(year, month, 0).getDate(); // 当前月的总天数
  if (month - 1 <= 0) return year - 1 + "-" + 12; // 如果是1月，年数往前推一年
  const lastMonthDay = new Date(year, parseInt(month) - 1, 0).getDate();
  let months = ''
  if ((month - 1) > 9) {
    months = (month - 1)
  } else {
    months = '0' + (month - 1)
  }
  if (lastMonthDay >= day) return year + "-" + months;
  if (day < nowMonthDay) return year + "-" + months; // 1个月前所在月的总天数小于现在的天日期
  return year + "-" + months; // 当前天日期小于当前月总天数
}
//下个月
export function getLastMonthNext (date) {
  const now = new Date(date)
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const nowMonthDay = new Date(year, month, 0).getDate(); // 当前月的总天数
  if (month + 1 >= 12) return year + 1 + "-" + '0' + 1; // 如果是1月，年数往前推一年
  const lastMonthDay = new Date(year, parseInt(month) + 1, 0).getDate();
  let months = ''
  if ((month + 1) > 9) {
    months = (month + 1)
  } else {
    months = '0' + (month + 1)
  }
  if (lastMonthDay >= day) return year + "-" + months;
  if (day < nowMonthDay) return year + "-" + months; // 1个月前所在月的总天数小于现在的天日期
  return year + "-" + months; // 当前天日期小于当前月总天数
}
//上一天
export function getLastDay (day) {
  let date = new Date(day);
  date = date - 86400000;
  let newDate = new Date(date);
  //获取新日期
  let newDay = newDate.getDate();
  //获取新月份
  let newMounth = newDate.getMonth() + 1;
  //获取新年份
  let newYear = newDate.getFullYear();
  //如果日期小于两位数
  if (newDay < 10) {
    newDay = '0' + newDay;
  }
  //如果月份小于两位
  if (newMounth < 10) {
    newMounth = "0" + newMounth;
  }
  return newYear + '-' + newMounth + '-' + newDay;
}
//下一天
export function getLastDayNext (day) {
  let date = +new Date(day);
  date = date + 86400000;
  let newDate = new Date(date);
  //获取新日期
  let newDay = newDate.getDate();
  //获取新月份
  let newMounth = newDate.getMonth() + 1;
  //获取新年份
  let newYear = newDate.getFullYear();
  //如果日期小于两位数
  if (newDay < 10) {
    newDay = '0' + newDay;
  }
  //如果月份小于两位
  if (newMounth < 10) {
    newMounth = "0" + newMounth;
  }
  return newYear + '-' + newMounth + '-' + newDay;
}
//获取当前日期的前后年、月、日
export function getDay (day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
}
//分钟转小时
export function minutesToHMS (minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}小时${remainingMinutes}分`
}
function doHandleMonth (month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}
// 二次确认弹窗
export function confirmFn (item, _this, callback = Function) {
  _this.$confirm(` ${item.content} , 是否继续?`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then((res) => {
    console.log(res);
    response(item.api, item.params).then((data) => {
      if (data.code) {
        _this.$message({ type: 'success', message: `${item.content}成功` });
        callback ? callback() : null;
      } else {
        _this.$message.error(`${item.content}失败，请重试`);
      }
    })
  }).catch(() => {
    _this.$message({ type: 'info', message: '操作已取消！' });
  });
}
//判断支付方式「 支付 」
export function getPayChannelType (val) {
  let ChannelType = ''
  switch (val) {
    case -1:
      ChannelType = '支付宝端内支付'
      break;
    case 0:
      ChannelType = '微信APP支付'
      break;
    case 1:
      ChannelType = '支付宝APP支付'
      break;
    case 2:
      ChannelType = '微信端内支付'
      break;
    case 3:
      ChannelType = '会员支付'
      break;
    case 4:
      ChannelType = '线下支付'
      break;
    case 5:
      ChannelType = '线下微信支付'
      break;
    case 6:
      ChannelType = '线下现金支付'
      break;
    case 7:
      ChannelType = '线下支付宝'
      break;
    case 8:
      ChannelType = '线下刷卡支付'
      break;
    case 9:
      ChannelType = '线下其他'
      break;
    case 10:
      ChannelType = '微信二维码支付'
      break;
    case 11:
      ChannelType = '支付宝二维码支付'
      break;
    case 12:
      ChannelType = '押金转支付'
      break;
    case 13:
      ChannelType = '美团券兑换'
      break;
    case 14:
      ChannelType = '通卡支付'
      break;
    case 15:
      ChannelType = '抖音券兑换'
      break;
    case 16:
      ChannelType = '微信小程序支付'
      break;
    case 17:
      ChannelType = '支付宝小程序支付'
      break;
    case 18:
      ChannelType = '微信信用支付'
      break;
    case 19:
      ChannelType = '支付宝信用扫码支付'
      break;
    case 20:
      ChannelType = '支付宝信用刷脸支付'
      break;
    case 21:
      ChannelType = '微信小程序支付'
      break;
    case 22:
      ChannelType = '支付宝小程序支付'
      break;
    case 30:
      ChannelType = '优惠券支付'
      break;
    case 31:
      ChannelType = '高德券兑换'
      break;
    case 33:
      ChannelType = '小时卡'
      break;
    case 34:
      ChannelType = '日卡'
      break;
    case 90:
      ChannelType = '销帐'
      break;
  }
  return ChannelType
}
//判断支付方式「 退款 」
export function getPayChannelTypeOut (val) {
  let ChannelType = ''
  switch (val) {
    case -1:
      ChannelType = '支付宝端内退款'
      break;
    case 0:
      ChannelType = '微信APP退款'
      break;
    case 1:
      ChannelType = '支付宝APP退款'
      break;
    case 2:
      ChannelType = '微信端内退款'
      break;
    case 3:
      ChannelType = '会员退款'
      break;
    case 4:
      ChannelType = '线下退款'
      break;
    case 5:
      ChannelType = '线下微信退款'
      break;
    case 6:
      ChannelType = '线下现金退款'
      break;
    case 7:
      ChannelType = '线下支付宝'
      break;
    case 8:
      ChannelType = '线下刷卡退款'
      break;
    case 9:
      ChannelType = '线下其他'
      break;
    case 10:
      ChannelType = '微信二维码退款'
      break;
    case 11:
      ChannelType = '支付宝二维码退款'
      break;
    case 12:
      ChannelType = '押金转退款'
      break;
    case 13:
      ChannelType = '美团券兑换'
      break;
    case 14:
      ChannelType = '通卡退款'
      break;
    case 15:
      ChannelType = '抖音券兑换'
      break;
    case 16:
      ChannelType = '微信小程序退款'
      break;
    case 17:
      ChannelType = '支付宝小程序退款'
      break;
    case 18:
      ChannelType = '微信信用退款'
      break;
    case 19:
      ChannelType = '支付宝信用扫码退款'
      break;
    case 20:
      ChannelType = '支付宝信用刷脸退款'
      break;
    case 21:
      ChannelType = '微信小程序退款'
      break;
    case 22:
      ChannelType = '支付宝小程序退款'
      break;
    case 30:
      ChannelType = '优惠券退款'
      break;
    case 31:
      ChannelType = '高德券兑换'
      break;
    case 33:
      ChannelType = '小时卡'
      break;
    case 34:
      ChannelType = '日卡'
      break;
    case 90:
      ChannelType = '销帐'
      break;
  }
  return ChannelType
}
